import { useEffect, useState } from "react";
import { PartnerApi } from "../api/partner.api";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useAuthStore } from "../store/auth.store";
import { useContacts } from "../hook/partner/contacts.partner.hook";
import { useContactsStore } from "../store/contacts.store";
import Modal from "../components/modals/Modal";
import { useTranslation } from "../hooks/useTranslation";

function Contacts() {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);
  const [page, setPage] = useState("quarter");
  const [personDetail, setPersonDetail] = useState(null);

  const contactMutation = useContacts();
  const contacts = useContactsStore((state) => state.contacts);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  useEffect(() => {
    setPagename(t("navigation.contacts"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      contactMutation.mutate({ token });
    }
  }, [token]);

  const Obchodnik = (data) => {
    return (
      <div className="col-6 col-md-6 col-lg-4">
        <div
          onClick={() => setPersonDetail(data)}
          class="octagon mx-auto mb-2 d-flex w-150px h-150px bgi-no-repeat bgi-size-contain bgi-position-center"
          style={{
            cursor: "pointer",
            backgroundImage:
              "url('" +
              (PartnerApi.url + "/person/" + data?.person_id + "/image.jpg") +
              "')",
          }}
        ></div>
        <div class="mb-7 text-center">
          <a
            href="javascript:;"
            class="text-gray-900 fw-bold text-hover-primary fs-3"
            onClick={() => setPersonDetail(data)}
          >
            {data?.first_name} {data?.last_name}
          </a>
          <div class="text-muted fs-6 fw-semibold">{data?.position}</div>
          <div
            class="text-muted fs-8 fw-semibold"
            style={{ fontSize: "0.6em" }}
          >
            {data?.vendors?.map((v, index) => (index > 0 ? ", " : "") + v.name)}
          </div>
        </div>
      </div>
    );
  };

  if (contactMutation.isLoading) {
    return t("common.loading");
  }

  return (
    <>
      <Modal
        title={personDetail?.first_name + " " + personDetail?.last_name}
        width="700px"
        show={personDetail && true}
        handleClose={() => setPersonDetail(null)}
      >
        <>
          <div className="row">
            <div className="col-12 col-md-4">
              <div
                class="octagon mx-auto mb-2 d-flex w-150px h-150px bgi-no-repeat bgi-size-contain bgi-position-center"
                style={{
                  cursor: "pointer",
                  backgroundImage:
                    "url('" +
                    (PartnerApi.url +
                      "/person/" +
                      personDetail?.person_id +
                      "/image.jpg") +
                    "')",
                }}
              ></div>
            </div>
            <div className="col-12 col-md-8 pt-8">
              <h3>{personDetail?.position}</h3>
              <div>
                <strong>{t("users.email")}:</strong>{" "}
                <a href={"mailto:" + personDetail?.email}>
                  {personDetail?.email}
                </a>
              </div>
              <div>
                <strong>{t("contacts.mobile")}:</strong>{" "}
                <a href={"tel:" + personDetail?.phone}>{personDetail?.phone}</a>
              </div>
            </div>
          </div>
          <div className="pt-5">
            <h3>{personDetail?.first_name} {t("company.helpWithVendors")}:</h3>
            <div className="row">
              {personDetail?.vendors?.map((v) => (
                <div className="col-4 col-md-3">
                  <div
                    className={
                      "card p-5 d-flex justify-content-center align-items-center h-100"
                    }
                  >
                    <img
                      className="mw-100"
                      style={{
                        aspectRatio: "1 / 1",
                        objectFit: "contain",
                      }}
                      src={
                        PartnerApi.url + "/vendor/" + v.vendor_id + "/logo.jpg"
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      </Modal>
      <div className="row">
        <div className="col-md-4">
          <h3 className="pt-5 pb-5">{t("company.offices")}</h3>
          {contacts?.offices?.map((o) => (
            <div className="card mb-5">
              <div className="card-body">
                <h3 className="text-primary">{o.name}</h3>
                <div className="row">
                  <div className="col-md-6">
                    <div>{o.street}</div>
                    <div>
                      {o.country}-{o.zip} {o.city}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <strong>{t("company.companyId")}:</strong> {o.ic}
                    </div>
                    <div>
                      <strong>{t("company.taxId")}:</strong> {o.dic}
                    </div>
                  </div>
                </div>
                <hr />
                <h4 className="text-primary">{t("settings.deliveryAddresses")}</h4>
                <div className="row">
                  {o.delivery_addresses?.map((d) => (
                    <div className="col-md-6">
                      <div>
                        <strong>{d.name}</strong>
                      </div>
                      <div>{d.street}</div>
                      <div>
                        {d.zip} {d.city}
                      </div>
                      <div>{d.country}</div>
                    </div>
                  ))}
                </div>
                {o.bank_accounts?.length > 0 && (
                  <div>
                    <hr />
                    <h4 className="text-primary">{t("company.bankAccount")}</h4>
                    {o.bank_accounts.map((b) => (
                      <div className="mb-5">
                        <strong>{b.bank}</strong>
                        <div>
                          {b.account_number}/{b.account_code}
                        </div>
                        <div>
                          <strong>SWIFT:</strong> {b.swift}
                        </div>
                        <div>
                          <strong>IBAN:</strong> {b.iban}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="col-md-8">
          <h3 className="pt-5 pb-5">{t("company.salesReps")}</h3>
          <div className="card">
            <div className="card-body">
              <div className="row">
                {contacts?.contacts?.sales?.map((c) => Obchodnik(c))}
              </div>
            </div>
          </div>
          <h3 className="mt-7 mb-7">{t("company.presalesSupport")}</h3>
          <div className="card">
            <div className="card-body">
              <div className="row">
                {contacts?.contacts?.presales?.map((c) => Obchodnik(c))}
              </div>
            </div>
          </div>
          <h3 className="mt-7 mb-7">{t("contacts.salesSupport")}</h3>
          <div className="card">
            <div className="card-body">
              <div className="row">
                {contacts?.contacts?.sasu?.map((c) => Obchodnik(c))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contacts;
